
import React from 'react';

export function Hero() {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      aria-label="Hero - Best Dental Clinic in Kondapur Hyderabad"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=modern%20luxury%20dental%20clinic%20interior%20with%20natural%20lighting%20soft%20teal%20and%20white%20color%20scheme%20minimalist%20design%20clean%20professional%20atmosphere%20bright%20windows%20contemporary%20furniture%20calming%20environment%20high%20end%20medical%20facility&width=1920&height=1080&seq=hero-bg-001&orientation=landscape)',
        }}
        role="img"
        aria-label="Sri Maruthi Teeth Empire Dental Clinic Interior"
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* LEFT COLUMN */}
          <div className="text-white">
            <div className="inline-block bg-teal-500/20 backdrop-blur-sm border border-teal-300/30 px-4 py-2 rounded-full mb-6">
              <span className="text-sm font-medium text-teal-100">
                <strong>Best Dental Clinic in Kondapur, Hyderabad</strong>
              </span>
            </div>

            <h2
              className="text-5xl md:text-6xl font-bold mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Your Smile Deserves <br />
              <span style={{ fontFamily: 'Inter, sans-serif' }}>Royal Treatment</span>
            </h2>

            <p className="text-lg text-gray-200 mb-8 max-w-xl">
              <strong>Sri Maruthi Teeth Empire</strong> — Kondapur&apos;s top-rated{' '}
              <strong>dental clinic</strong> on Botanical Garden Road,
              Hyderabad. Expert <strong>dental implants</strong>, painless{' '}
              <strong>root canal</strong>, <strong>cosmetic dentistry</strong>{' '}
              &amp; <strong>teeth whitening</strong> near Kondapur.
            </p>

            <div className="flex flex-wrap gap-4 mb-10">
              <a
                href="#booking"
                onClick={(e) => { e.preventDefault(); scrollToBooking(); }}
                aria-label="Schedule a dental consultation at Sri Maruthi Teeth Empire Kondapur"
                className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-xl whitespace-nowrap cursor-pointer"
              >
                Schedule Consultation
              </a>
              <a
                href="tel:+918340978930"
                aria-label="Call Sri Maruthi Teeth Empire dental clinic"
                className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                Call Now
              </a>
            </div>

            <div className="flex flex-wrap gap-8">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 backdrop-blur-sm rounded-full">
                  <i className="ri-user-smile-line text-2xl text-teal-300" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold">5000+</div>
                  <div className="text-sm text-gray-300">Happy Patients</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 backdrop-blur-sm rounded-full">
                  <i className="ri-award-line text-2xl text-teal-300" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold">10+</div>
                  <div className="text-sm text-gray-300">Years Experience</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 backdrop-blur-sm rounded-full">
                  <i className="ri-star-fill text-2xl text-yellow-400" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold">4.9★</div>
                  <div className="text-sm text-gray-300">Google Rating</div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN - IMAGE */}
          <div className="hidden md:block">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/4c54787fd2047152d108467e5113439e/c996f7e3eb5521b78694baa4c83e4d96.jpeg"
                  alt="Sri Maruthi Teeth Empire - Best Dental Clinic Interior in Kondapur Hyderabad"
                  title="Sri Maruthi Teeth Empire - Top Rated Dental Clinic in Kondapur Hyderabad"
                  width="600"
                  height="500"
                  className="w-full h-full object-cover object-top"
                  loading="eager"
                />
              </div>
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-500 rounded-full">
                    <i className="ri-time-line text-xl text-white" aria-hidden="true"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-900">Open All&nbsp; Days</div>
                    <div className="text-xs text-gray-600">9 AM – 8 PM | Kondapur</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
